/**
 * Arclo: shows "qty × unit price = total" under the product price on the
 * product page, so increasing the quantity selector visibly updates the
 * total the customer will pay (the theme's price element only ever shows
 * the per-unit price by default).
 *
 * Reads the currently displayed unit price straight from the DOM (instead
 * of hard-coding a currency format), so it stays correct through sales,
 * discounts, and variant switches without any extra configuration.
 */
(function () {
  function parseAndScaleMoney(text, qty) {
    var match = text.match(/([\d.,]+)/);
    if (!match) return null;
    var numStr = match[1].replace(/,/g, '');
    var unit = parseFloat(numStr);
    if (isNaN(unit)) return null;
    var decimals = (match[1].split('.')[1] || '').length || 2;
    var total = (unit * qty).toFixed(decimals);
    return text.slice(0, match.index) + total + text.slice(match.index + match[1].length);
  }

  function getUnitPriceText(priceContainer) {
    var priceEl = priceContainer.querySelector('.price');
    if (!priceEl) return null;

    var saleEl = priceEl.querySelector('.price__sale .price-item--sale');
    var regularEl = priceEl.querySelector('.price__regular .price-item--regular');
    var candidate = null;

    if (saleEl) {
      var saleWrap = saleEl.closest('.price__sale');
      if (!saleWrap || getComputedStyle(saleWrap).display !== 'none') candidate = saleEl;
    }
    if (!candidate && regularEl) {
      var regWrap = regularEl.closest('.price__regular');
      if (!regWrap || getComputedStyle(regWrap).display !== 'none') candidate = regularEl;
    }

    return candidate ? candidate.textContent.trim() : null;
  }

  function ensureTotalEl(priceContainer) {
    var el = priceContainer.querySelector('[data-arclo-qty-total]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-arclo-qty-total', '');
      el.className = 'caption';
      el.style.marginTop = '0.4rem';
      el.style.color = 'rgba(var(--color-foreground), 0.75)';
      priceContainer.appendChild(el);
    }
    return el;
  }

  function initProductInfo(productInfo) {
    var priceContainer = productInfo.querySelector('[id^="price-"]');
    if (!priceContainer) return;

    var observer;

    function sync() {
      var qtyInput = productInfo.querySelector('.quantity__input');
      if (!qtyInput) return;

      var qty = parseInt(qtyInput.value, 10) || 1;

      if (observer) observer.disconnect();

      var totalEl = ensureTotalEl(priceContainer);

      if (qty <= 1) {
        totalEl.hidden = true;
        totalEl.textContent = '';
      } else {
        var unitText = getUnitPriceText(priceContainer);
        var totalText = unitText ? parseAndScaleMoney(unitText, qty) : null;

        if (totalText) {
          totalEl.hidden = false;
          totalEl.textContent = qty + ' × ' + unitText + ' = ' + totalText;
        } else {
          totalEl.hidden = true;
        }
      }

      if (observer) {
        observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
      }
    }

    sync();

    productInfo.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.classList && target.classList.contains('quantity__input')) {
        sync();
      }
    });

    if ('MutationObserver' in window) {
      observer = new MutationObserver(sync);
      observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
    }
  }

  function init() {
    document.querySelectorAll('product-info').forEach(initProductInfo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
